const { BASE_URL } = require("./client");

const POST_REVENUE_DATA = BASE_URL + "/api/revenueform";
const GET_REVENUE_DATA = BASE_URL + "/api/revenueform";

module.exports = {
  POST_REVENUE_DATA,
  GET_REVENUE_DATA,
};
